export enum ImportanceVegetationPlacette {

    Nulle = 0,
    TresFaible = 1,
    Faible = 2,
    Moyenne = 3,
    Importante = 4,
    TresImportante = 5,
    Indeterminable = 6,
    NonRenseignee = 7
}
